import CafeteriaMenuManagementTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useNavigate } from 'react-router';
import SecundButton from 'components/form/buttons/secundButton';

import * as S from './styles';

export default function CafeteriaCustomizationsPage() {
  const { CustomList }: any = useTypedSelector((state) => state.Cafeteria);

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/panel/cafeteria/customizations/create');
  };

  return (
    <S.Container>
      <S.Head>
        <S.Title>Customizations</S.Title>
        <SecundButton hasIcon={true} onClick={handleRedirect}>
          Create new
        </SecundButton>
      </S.Head>
      <Gap size="20px" />
      <CafeteriaMenuManagementTable menuList={CustomList.data} loading={CustomList.loading} />
    </S.Container>
  );
}
